import { pgEnum } from "drizzle-orm/pg-core";

export const account_status = pgEnum("account_status", [
  "active",
  "inactive",
  "pending_verify",
]);
